import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { typeLabels } from "@/mocks/movies";
import { formatViews } from "@/lib/movieUtils";

interface MovieCardProps {
  movie: Movie;
  showViews?: boolean;
}

export default function MovieCard({ movie, showViews = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-500/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 高清影视在线观看推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent opacity-70" />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50">
          {typeLabels[movie.type]}
        </span>
        {movie.rating > 0 && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-xs font-semibold bg-background-50/80 text-primary-300 flex items-center gap-1">
            <i className="ri-star-fill text-accent-400" />
            {movie.rating.toFixed(1)}
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 px-3 pb-2 pt-6">
          <p className="text-xs text-foreground-700 line-clamp-1">
            {movie.year} · {movie.region}
          </p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-300 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-2 flex items-center gap-2 flex-wrap">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="px-2 py-0.5 rounded-full text-xs bg-secondary-900/60 text-secondary-200"
            >
              {genre}
            </span>
          ))}
        </div>
        {showViews && (
          <p className="mt-2 text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-play-circle-line text-primary-400" />
            {formatViews(movie.views)}
          </p>
        )}
      </div>
    </Link>
  );
}